import React from 'react';

export const getMonday = (dateValue: Date) => {
  const date = new Date(dateValue);
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);

  return new Date(date.setDate(diff));
};

const today = new Date();
const currentMonday = getMonday(today);
const currentSunday = new Date(currentMonday);
currentSunday.setDate(currentMonday.getDate() + 6);

export const initialStartDate = currentMonday.toISOString().split('T')[0];
export const initialEndDate = currentSunday.toISOString().split('T')[0];

export const formatDateKey = (date: Date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${y}-${m}-${day}`;
};

export const getCheckinTime = (checkinTime: string) => {
  const checkinDate = new Date(checkinTime);
  const hours = checkinDate.getHours().toString().padStart(2, '0');
  const minutes = checkinDate.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
};

export const getLateColor = (session: any) => {
  if (!session) return '#f0f0f0';

  const workingTypes = ['on_site', 'remote', 'remote_sick'];
  if (!workingTypes.includes(session.sessionType)) {
    return 'transparent';
  }

  const checkinDate = new Date(session.checkinTime);
  const hours = checkinDate.getHours();
  const minutes = checkinDate.getMinutes();

  if (hours > 9 || (hours === 9 && minutes > 5)) {
    return '#ffd2bf';
  }

  if (hours === 9 && minutes > 0 && minutes <= 5) {
    return '#ffefcd';
  }

  return 'transparent';
};

export const getSessionIcon = (sessionType: string) => {
  switch (sessionType) {
    case 'on_site':
      return '🏢';
    case 'remote':
      return '🏠';
    case 'business_trip':
      return '✈️';
    case 'sick':
      return '🤒';
    case 'remote_sick':
      return '🏥';
    case 'vacation':
      return '🌴';
    default:
      return <i className="fa fa-clock-o" aria-hidden="true" title={sessionType} />;
  }
};

export const getSentence = (totalOnSize: number) => {
  switch (totalOnSize) {
    case 0:
      return "wasn't on site";
    case 1:
      return `was ${totalOnSize} day on site`;
    default:
      return `was ${totalOnSize} days on site`;
  }
};

export const isSessionLate = (session: any) => {
  if (!session || !session.checkinTime || !['on_site', 'remote', 'remote_sick'].includes(session.sessionType)) return false;
  const date = new Date(session.checkinTime);

  return date.getHours() > 9 || (date.getHours() === 9 && date.getMinutes() > 0);
};

export const generateWeek = (startString: string) => {
  const dates: Array<Date> = [];
  const [year, month, day] = startString.split('-').map(Number);
  const startDate = new Date(year, month - 1, day);

  for (let i = 0; i < 7; i++) {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);
    dates.push(currentDate);
  }

  return dates;
};

export const shiftWeekRange = (startString: string, direction: 'prev' | 'next') => {
  const [year, month, day] = startString.split('-').map(Number);
  const currentStart = new Date(year, month - 1, day);
  const offset = direction === 'prev' ? -7 : 7;

  const newStart = new Date(currentStart);
  newStart.setDate(currentStart.getDate() + offset);

  const newEnd = new Date(newStart);
  newEnd.setDate(newStart.getDate() + 6);

  return {
    startDate: formatDateKey(newStart),
    endDate: formatDateKey(newEnd),
  };
};
